<template>
  <b-row v-if="!isLoading" v-bind:class="{ spinner: isLoading }" class="focuskpi-bar">
    <b-col cols="12">
      <b-row>
        <h2 class="ml-3">{{ $t("Webportal.CX.Dashboard.Topbar.Headline")}}</h2>
        <span 
          class="ml-2" 
          v-if="$te(`Webportal.CX.Dashboard.Topbar.Headline`) && $te(`Webportal.CX.Dashboard.Topbar.Text`)"
        >
          <font-awesome-icon  id="ExplainTopbarElement"
            class="clickable"
            :icon="['far', 'question-circle']"
            @click="showHelpPopup=!showHelpPopup" />
        </span>
      </b-row>
    </b-col>
    <template v-for="kpi in kpis">
      <b-col class="mb-1" :key="kpi.name" v-if="kpi.value != undefined">
        <FocusKpiBarItem 
          :name="kpi.name" 
          :type="kpi.type"
          :value="kpi.value"
          :onlyLogo="kpi.onlyLogo == 1" 
          :threshold="kpi.threshold" 
          :colorRange="ColorRange"/>
      </b-col>
    </template>
    <GenericHelpPopup 
      :title="$t(`Webportal.CX.Dashboard.Topbar.Headline`)"
      v-if="showHelpPopup"
      @close="showHelpPopup=false"
      >
      <div v-html="$t(`Webportal.CX.Dashboard.Topbar.Text`)"></div>
    </GenericHelpPopup>
  </b-row>
</template>

<script>
import FocusKpiBarItem from "./FocusKpiBarItem.vue";
import DashboardService from "@/services/DashboardService";
import GenericHelpPopup from "@/components/Shared/GenericHelpPopup";

import EventBus from "@/services/EventBus";

export default {
  components: {
    FocusKpiBarItem,
    GenericHelpPopup
  },
  props: {
    ColorRange: Array,
    cancelToken: Object,
    scoreId: Number,
    clientLocationId: Number
  },
  data: function(){
    return {
      kpis: {},
      firstaid_solved: 0,
      firstaid_all: 0,
      isLoading: true,
      showHelpPopup: false
    }
  },
  created() {
    this.loadData();
    EventBus.$on("FirstAidPercentage", ({solved, all}) => {
      this.firstaid_solved = solved;
      this.firstaid_all = all;
      if(this.kpis.firstaidkits) {
        this.kpis.firstaidkits.value = this.firstaid_solved;
        this.kpis.firstaidkits.threshold = this.firstaid_all;
      }
    });
    EventBus.$emit("queryFirstAidPercentage");
  },
  methods: {
    loadData: function() {
      DashboardService.getDealerFocuskpis(this.clientLocationId, this.cancelToken, this.scoreId).then(res => {
        this.kpis = res.data
        this.loadKpiGroups();
        this.kpis.firstaidkits.value = this.firstaid_solved;
        this.kpis.firstaidkits.threshold = this.firstaid_all;
        this.isLoading = false; 
      }).catch(_);
    },
    loadKpiGroups: function() {            
      // Get the average response time
      DashboardService.GetDealerKpis(this.clientLocationId, this.cancelToken, -1, "Enquiry Responsiveness", "").then(res => {
        if (res.data[0].Kpis == null) {
          this.$delete(this.kpis, 'avg_responsetime');
        } else {
          var results = res.data[0].Kpis.map(kpi => kpi.SurveyInstances?.[0].QuestionResult)
          var sum = results.reduce((a,b) => a + b, null);
          var avg = sum/results.filter(r => r != null).length;
          this.kpis.avg_responsetime.value = avg;
        }
      }).catch( error => {
        console.error(error)
      });

      // Get NC/UC - Visualpresentation
      DashboardService.GetDealerKpis(this.clientLocationId, this.cancelToken, -1, "CX Top Bar KPI", "").then(res => {
        if (res.data[0].Kpis == null) {
          this.$delete(this.kpis, 'ncuc_visualpresentation');
        } else {
          this.kpis.ncuc_visualpresentation.value = res.data[0].Kpis[0]?.AggregatedResultOfLastSurveyInstancesPerSurvey;
        }
      }).catch( error => {
        console.error(error)
      });
    }
  },
  watch: {
    clientLocationId: function() { this.loadData()},
    scoreId: function() { this.loadData() },
  }
}
</script>

<style lang="scss" scoped>
  .focuskpi-bar {
    flex-wrap: wrap;
    justify-content: space-between;

    h2 {
      font-size: 1.5rem;
      font-weight: bold;
    }

    .col {
      margin: 0.2rem 0;
      min-width: 350px;
      max-width: 50%;
    }
  }
</style>